__turbopack_context__.v({
  "allResources": "ResourceOverview-module__zRrQrG__allResources",
  "breadcrumbs": "ResourceOverview-module__zRrQrG__breadcrumbs",
  "clearSearchButton": "ResourceOverview-module__zRrQrG__clearSearchButton",
  "frameParent": "ResourceOverview-module__zRrQrG__frameParent",
  "headerWrap": "ResourceOverview-module__zRrQrG__headerWrap",
  "headerWrapper": "ResourceOverview-module__zRrQrG__headerWrapper",
  "horizontalSwiper": "ResourceOverview-module__zRrQrG__horizontalSwiper",
  "imageContainer": "ResourceOverview-module__zRrQrG__imageContainer",
  "imageIcon": "ResourceOverview-module__zRrQrG__imageIcon",
  "imageOverlay": "ResourceOverview-module__zRrQrG__imageOverlay",
  "innerWrapper": "ResourceOverview-module__zRrQrG__innerWrapper",
  "isStuck": "ResourceOverview-module__zRrQrG__isStuck",
  "light": "ResourceOverview-module__zRrQrG__light",
  "mobileViewAllWrapper": "ResourceOverview-module__zRrQrG__mobileViewAllWrapper",
  "moduleWrapper": "ResourceOverview-module__zRrQrG__moduleWrapper",
  "navSelector": "ResourceOverview-module__zRrQrG__navSelector",
  "navSelectorActive": "ResourceOverview-module__zRrQrG__navSelectorActive",
  "navigation": "ResourceOverview-module__zRrQrG__navigation",
  "navigationSwiper": "ResourceOverview-module__zRrQrG__navigationSwiper",
  "navigationWrapper": "ResourceOverview-module__zRrQrG__navigationWrapper",
  "outerWrapper": "ResourceOverview-module__zRrQrG__outerWrapper",
  "resourceGrid": "ResourceOverview-module__zRrQrG__resourceGrid",
  "resourceWrapper": "ResourceOverview-module__zRrQrG__resourceWrapper",
  "resultsFilteredPagination": "ResourceOverview-module__zRrQrG__resultsFilteredPagination",
  "resultsGroup": "ResourceOverview-module__zRrQrG__resultsGroup",
  "resultsWrapper": "ResourceOverview-module__zRrQrG__resultsWrapper",
  "searchButton": "ResourceOverview-module__zRrQrG__searchButton",
  "searchButtonMobile": "ResourceOverview-module__zRrQrG__searchButtonMobile",
  "searchIcon": "ResourceOverview-module__zRrQrG__searchIcon",
  "searchInput": "ResourceOverview-module__zRrQrG__searchInput",
  "searchInputBar": "ResourceOverview-module__zRrQrG__searchInputBar",
  "slide": "ResourceOverview-module__zRrQrG__slide",
  "stickyNavWrapper": "ResourceOverview-module__zRrQrG__stickyNavWrapper",
  "stickyTrigger": "ResourceOverview-module__zRrQrG__stickyTrigger",
  "suggestionItem": "ResourceOverview-module__zRrQrG__suggestionItem",
  "suggestionsBox": "ResourceOverview-module__zRrQrG__suggestionsBox",
  "swiper-slide": "ResourceOverview-module__zRrQrG__swiper-slide",
  "swiper-wrapper": "ResourceOverview-module__zRrQrG__swiper-wrapper",
  "swiperNavigationWrapper": "ResourceOverview-module__zRrQrG__swiperNavigationWrapper",
  "swiperSlide": "ResourceOverview-module__zRrQrG__swiperSlide",
  "trendingGroup": "ResourceOverview-module__zRrQrG__trendingGroup",
  "trendingGroupInternal": "ResourceOverview-module__zRrQrG__trendingGroupInternal",
});
